import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import { Textbox, Radiobox, Select, Textarea } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";

class VolunteerAddEdit extends Component {
  constructor(props) {
    super(props);

    var _vno,
      _name,
      _location,
      _phone,
      _mode,
      _hasNameError,
      _hasPhoneError,
      _hasLocationError;
    if (this.props.pData._id == "NA") {
      _vno = "";
      _name = "";
      _phone = "";
      _location = "";
      _hasNameError = true;
      _hasPhoneError = true;
      _hasLocationError = true;
      _mode = "add";
    } else {
      _vno = this.props.pData.vno;
      _name = this.props.pData.name;
      _phone = this.props.pData.phone;
      _location = this.props.pData.location;
      _hasNameError = false;
      _hasPhoneError = false;
      _hasLocationError = false;
      _mode = "edit";
    }

    this.state = {
      vno: _vno,
      name: _name,
      phone: _phone,
      location: _location,
      spinnerClass: "collapse",
      dataClass: "",
      validate: false,
      hasNameError: _hasNameError,
      hasPhoneError: _hasPhoneError,
      hasLocationError: _hasLocationError,
      mode: _mode
    };
  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Name</div>
              <div className="col col-md-3">
                <Textbox
                  value={this.state.name}
                  placeholder="Enter Name"
                  onChange={(name, e) => {
                    this.setState({ name });
                  }}
                  onBlur={e => {}}
                  validationOption={{
                    name: "Name",
                    check: true,
                    required: true
                  }}
                  validate={this.state.validate}
                  validationCallback={res =>
                    this.setState({ hasNameError: res, validate: false })
                  }
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Phone #</div>
              <div className="col col-md-3">
                <Textbox
                  value={this.state.phone}
                  placeholder="Enter Phone #"
                  onChange={(phone, e) => {
                    this.setState({ phone });
                  }}
                  onBlur={e => {}}
                  validationOption={{
                    name: "Phone",
                    check: true,
                    required: true
                  }}
                  validate={this.state.validate}
                  validationCallback={res =>
                    this.setState({ hasPhoneError: res, validate: false })
                  }
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Location</div>
              <div className="col col-md-3">
                <Textbox
                  value={this.state.location}
                  placeholder="Enter Location"
                  onChange={(location, e) => {
                    this.setState({ location });
                  }}
                  onBlur={e => {}}
                  validationOption={{
                    name: "Location",
                    check: true,
                    required: true
                  }}
                  validate={this.state.validate}
                  validationCallback={res =>
                    this.setState({ hasLocationError: res, validate: false })
                  }
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className="btn btn-primary btn-md mr-2"
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  getHeading() {
    if (typeof this.state.vno == "undefined" || this.state.vno == "") {
      return "Add New Volunteer";
    } else {
      return "Edit Volunteer #" + this.state.vno;
    }
  }

  showBusy(mode) {
    if (mode === true) {
      this.setState({ spinnerClass: "" });
      this.setState({ dataClass: "collapse" });
    } else {
      this.setState({ spinnerClass: "collapse" });
      this.setState({ dataClass: "" });
    }
  }

  onSaveClick = async e => {
    e.preventDefault();
    this.toggleValidating(true);

    if (
      !this.state.hasNameError &&
      !this.state.hasPhoneError &&
      !this.state.hasLocationError
    ) {
      const obj = {
        name: this.state.name,
        phone: this.state.phone,
        location: this.state.location
      };
      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/volunteer/add",
            obj
          )
          .then(res => console.log(res.data));
        this.toggleValidating(false);
        this.setState({ hasNameError: true });
        this.ClearData();
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Volunteer Added !!!"
        });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/volunteer/update/" +
              this.props.pData._id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Volunteer Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }

  ClearData() {
    this.setState({ name: "", location: "", phone: "", hasNameError: true });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default VolunteerAddEdit;
